import { ModuleWithProviders, NgModule } from '@angular/core';

import { VerifyModule } from './lib/verify/verify.module';
import { MapPickModule } from './lib/map-pick/map-pick.module';
import { QrCodeModule } from './lib/qr-code/qr-code.module';
import { LoginBgModule } from './lib/login-bg/login-bg.module';
import { LockPageModule } from './lib/lock-page/lock-page.module';
import { LoadingModule } from './lib/loading/loading.module';
import { CustomCountUpModule } from './lib/count-up/count-up.module';
import { DynamicComponentLoaderModule } from './lib/dynamic-component-loader/dynamic-component-loader.module';
import { ImgUrlPipeModule } from './lib/pzCore/img-url.pipe';
import { AuthModule } from './lib/auth/auth.module';
import { ReportModule } from './lib/report/report.module';
import { MapCameraModule } from './lib/map-camera/map-camera.module';
import { MapThreeModule } from './lib/map-three/map-three.module';
import { PzCardModule } from './lib/pz-card/pz-card.module';
import { TimeRangeModule  } from './lib/time-range/time-range.module';
import { MultiTimeRangeModule } from './lib/multi-time-range/multi-time-range.module';
import { SubmitModule } from './lib/submit-button-group/submit.module';

export * from './lib/verify';
export * from './lib/login-bg';
export * from './lib/model';
export * from './lib/lock-page';
export * from './lib/loading';
export * from './lib/count-up';
export * from './lib/pzCore';
export * from './lib/auth';
export * from './lib/message';
export * from './lib/map-pick';
export * from './lib/qr-code';
export * from './lib/dynamic-component-loader';
export * from './lib/report';
export * from './lib/map-camera';
export * from './lib/map-three';
export * from './lib/pz-card';
export * from './lib/util';
export * from './lib/time-range';
export * from './lib/multi-time-range';
export * from './lib/submit-button-group';

@NgModule({
    exports: [
        VerifyModule,
        LoginBgModule,
        LockPageModule,
        QrCodeModule,
        LoadingModule,
        CustomCountUpModule,
        MapPickModule,
        DynamicComponentLoaderModule,
        ImgUrlPipeModule,
        AuthModule,
        ReportModule,
        MapCameraModule,
        PzCardModule,
        TimeRangeModule,
        MultiTimeRangeModule,
        SubmitModule,
        MapThreeModule
    ]
})
export class PzUnitModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: PzUnitModule
        };
    }
}
